module.exports = __webpack_public_path__ + "img/arnela.9ac66ce7.jpg";